module.exports = __webpack_public_path__ + "static/man-sunset-square-mirror.ac37bf08.jpg";